// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__UUaYT","sidebar_button":"Sidebar_sidebar_button__41ttG","active":"Sidebar_active__4OJ50","icon":"Sidebar_icon__LlkLL","nameID":"Sidebar_nameID__mdyQL"};